'use client';

import { useState } from 'react';
import { Button } from 'mmds';
import { normaliseGoogleSizeGuideData } from '@app/lib/google/size-guide';
import cn from 'clsx';
import s from './size-guide-table.module.css';
import clsx from 'clsx';

interface SizeGuideTableProps {
    gender: string;
    productType: string;
    googleSizeGuideData: any; //TODO
}

const SizeGuideTable = ({
    gender,
    productType,
    googleSizeGuideData,
}: SizeGuideTableProps) => {
    const [isCentimetres, setIsCentimetres] = useState(true);
    const unit = isCentimetres ? 'CM' : 'IN';
    const productSizeGuide = normaliseGoogleSizeGuideData(
        googleSizeGuideData,
        gender,
        [productType],
        unit
    );

    if (!productSizeGuide || productSizeGuide.length === 0) {
        return <p>One size fits most.</p>;
    }
    const headers = productSizeGuide[0];
    const rows = productSizeGuide.slice(1);
    const productTypeClass = productType.toLowerCase().replace(/\s+/g, '-');
    return (
        <>
            <div className={cn(s.cluster)}>
                <Button
                    onClick={() => setIsCentimetres(true)}
                    variant="quite"
                    label="CM"
                    active={isCentimetres}
                    inactive={!isCentimetres}
                />
                <Button
                    onClick={() => setIsCentimetres(false)}
                    variant="quite"
                    label="IN"
                    active={!isCentimetres}
                    inactive={isCentimetres}
                />
            </div>
            <div
                className={cn('mmds-copy-three', 'divider', s.tableContainer)}
                data-color="steel"
            >
                <div className={s.head}>
                    <div className={clsx(s.row, s[productTypeClass])}>
                        {headers?.map((header, index) => (
                            <div className={s.cell} key={index}>
                                {header}
                            </div>
                        ))}
                    </div>
                </div>
                <div className={s.body}>
                    {rows?.map((row, rowIndex) => (
                        <div
                            className={clsx(s.row, s[productTypeClass])}
                            key={rowIndex}
                        >
                            {row.map((cell, cellIndex) => (
                                <div className={s.cell} key={cellIndex}>
                                    {cell}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default SizeGuideTable;
